/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateTimesheetEntryDataTimesheetBreaksInner } from './CreateTimesheetEntryDataTimesheetBreaksInner';
import {
    CreateTimesheetEntryDataTimesheetBreaksInnerFromJSON,
    CreateTimesheetEntryDataTimesheetBreaksInnerFromJSONTyped,
    CreateTimesheetEntryDataTimesheetBreaksInnerToJSON,
    CreateTimesheetEntryDataTimesheetBreaksInnerToJSONTyped,
} from './CreateTimesheetEntryDataTimesheetBreaksInner';

/**
 * 
 * @export
 * @interface BulkCreateTimesheetEntriesTimesheetEntryData
 */
export interface BulkCreateTimesheetEntriesTimesheetEntryData {
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTimesheetEntriesTimesheetEntryData
     */
    employeeId?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTimesheetEntriesTimesheetEntryData
     */
    shiftId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTimesheetEntriesTimesheetEntryData
     */
    locationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTimesheetEntriesTimesheetEntryData
     */
    jobRoleId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof BulkCreateTimesheetEntriesTimesheetEntryData
     */
    startedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BulkCreateTimesheetEntriesTimesheetEntryData
     */
    endedAt?: Date;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkCreateTimesheetEntriesTimesheetEntryData
     */
    tags?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof BulkCreateTimesheetEntriesTimesheetEntryData
     */
    notes?: string | null;
    /**
     * 
     * @type {Array<CreateTimesheetEntryDataTimesheetBreaksInner>}
     * @memberof BulkCreateTimesheetEntriesTimesheetEntryData
     */
    timesheetBreaks?: Array<CreateTimesheetEntryDataTimesheetBreaksInner>;
}

/**
 * Check if a given object implements the BulkCreateTimesheetEntriesTimesheetEntryData interface.
 */
export function instanceOfBulkCreateTimesheetEntriesTimesheetEntryData(value: object): value is BulkCreateTimesheetEntriesTimesheetEntryData {
    return true;
}

export function BulkCreateTimesheetEntriesTimesheetEntryDataFromJSON(json: any): BulkCreateTimesheetEntriesTimesheetEntryData {
    return BulkCreateTimesheetEntriesTimesheetEntryDataFromJSONTyped(json, false);
}

export function BulkCreateTimesheetEntriesTimesheetEntryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCreateTimesheetEntriesTimesheetEntryData {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'shiftId': json['shiftId'] == null ? undefined : json['shiftId'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'jobRoleId': json['jobRoleId'] == null ? undefined : json['jobRoleId'],
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'endedAt': json['endedAt'] == null ? undefined : (new Date(json['endedAt'])),
        'tags': json['tags'] == null ? undefined : json['tags'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'timesheetBreaks': json['timesheetBreaks'] == null ? undefined : ((json['timesheetBreaks'] as Array<any>).map(CreateTimesheetEntryDataTimesheetBreaksInnerFromJSON)),
    };
}

  export function BulkCreateTimesheetEntriesTimesheetEntryDataToJSON(json: any): BulkCreateTimesheetEntriesTimesheetEntryData {
      return BulkCreateTimesheetEntriesTimesheetEntryDataToJSONTyped(json, false);
  }

  export function BulkCreateTimesheetEntriesTimesheetEntryDataToJSONTyped(value?: BulkCreateTimesheetEntriesTimesheetEntryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'shiftId': value['shiftId'],
        'locationId': value['locationId'],
        'jobRoleId': value['jobRoleId'],
        'startedAt': value['startedAt'] == null ? undefined : ((value['startedAt']).toISOString()),
        'endedAt': value['endedAt'] == null ? undefined : ((value['endedAt']).toISOString()),
        'tags': value['tags'],
        'notes': value['notes'],
        'timesheetBreaks': value['timesheetBreaks'] == null ? undefined : ((value['timesheetBreaks'] as Array<any>).map(CreateTimesheetEntryDataTimesheetBreaksInnerToJSON)),
    };
}

